import { __assign, __rest } from "tslib";
import { useSingleCalendarState } from './useSingleCalendarState';
import { isEqualDate, isSameCell } from './utils';
export function useMultipleCalendarState(props) {
    var value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, restProps = __rest(props, ["value", "defaultValue", "onChange"]);
    var singleState = useSingleCalendarState(__assign(__assign({}, restProps), { value: value === null || value === void 0 ? void 0 : value[0], onChange: function (event) {
            var _a;
            var values = (_a = value === null || value === void 0 ? void 0 : value.slice()) !== null && _a !== void 0 ? _a : [];
            var index = values.findIndex(function (val) { return isEqualDate(val, event.value); });
            if (index !== -1) {
                values.splice(index, 1);
            }
            else {
                values.push(event.value);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange({ value: values });
        } }));
    function getCellState(cellValue, viewDate) {
        var _a;
        var baseCellState = singleState.getCellState(cellValue, viewDate);
        return __assign(__assign({}, baseCellState), { isSelected: (_a = value === null || value === void 0 ? void 0 : value.some(function (val) { return isSameCell(singleState.activeView, val, cellValue); })) !== null && _a !== void 0 ? _a : false });
    }
    return __assign(__assign({}, singleState), { mode: 'multiple', value: value, getCellState: getCellState });
}
